export default {
  N_A: `N/A`,
  UNASSIGNED_SHIFT: `Unassigned`,
  VARIABLE_END_TIME: `Variable end time`,
  OVERTIME: `Overtime`,
  ON_CALL: `On call`,
  IS_ABSENT: `Is absent`,
  IS_ARRIVING_AT: `Arrived at {{ arrivalTime }}`,
  UNAVAILABLE_ISSUES: `Has issues that are unavailable due to missing permissions.`,
  IN_TIME_OFF: `On time off`,
  UNAPPROVED_TIME_OFF: `Unapproved time off`,
  IS_LEAVING_AT: `Left at {{ departureTime }}`,
  REPLACES_THIS_EMPLOYEE: `Replaces {{ name }}`,
  IS_IRREPLACEABLE: `Should not be replaced`,
  NEEDS_REPLACEMENT: `Needs to be replaced`,
  NO_EMPLOYEE_AVAILABLE: `No employee available`,
  HAS_SPECIFIC_REQUIREMENTS: `Has specific requirements`,
  COVEREDOTHERUNIT: `Covered by other unit`,
  TODAY: `Today`,
  ABSENCES: `Absences`,
  PROJECT_VIEW_NO_PROJECTS: `Please choose a project in the filters to display it when you are in project view.`,
  TEAM_VIEW_NO_TEAMS: `Please choose a team in the filters to display it when you are in team view.`,
  NO_FILTER_LARGE_COMPANY: `Please choose a filter from the filter bar to load the schedule.`,
  NO_PROJECT: `No Project`,
  NO_TEAM: `No Team`,
  EVENT_SUMMARY: `<0>{{ name }}</0> - {{ positionName }} <1>({{ start }} - {{ end }})</1>`,
  SEE_PUNCHCARD: `See punchcard`,
  NO_EVENTS_TO_SHOW: `No shifts to show.`,
  WAGE_PREMIUM_HOUR: `\${{amount}} extra per hour`,
  WAGE_PREMIUM_SHIFT: `\${{amount}} extra per shift`,
  WAGE_PREMIUM_MULTIPLICATOR: `{{amount}}x multiplier`,
  IMPORT: `Import shifts`,
  NOTHING_TO_SHOW: `No shifts or time off`,
  SHIFT_IN_LIST_WARNING: `This shift is currently in a contact list, assigning a user to it will make it unavailable in that list.`,
  SHIFT_IN_LIST_ERROR_MAKING_INELIGIBLE: `There was an error while making the shift unavailable in the list, please navigate to the list and make sure the shift is no longer available.`,
  NO_PROCEDURE_WARNING: `There is no procedure included in the schedule. The users won't be filtered or sorted.`,
  SUMMARY: {
    TITLE: `Summary`,
    PLANNED_HOURS: `{{ numberOfAssignedHours }} / {{ numberOfHours }} hours`,
    NUMBER_OF_SHIFTS: `{{ numberOfAssignedEvents }} / {{ numberOfEvents }} shifts`
  },
  WARNINGS: {
    CANT_DROP_PROJECT: `Moving to project row is not permitted`,
    CANT_DROP_TIMEOFF: `Moving to time off row in not permitted`,
    CANT_DROP_ABSENCE: `Moving to absence row in not permitted`,
    CANT_DROP_UNASSIGNABLE: `This position is unassignable`,
    NO_SHIFT_TO_SYNC: `No shift to sync`,
    NO_SHIFT_TO_SYNC_DESC: `There is no shift available to be sync, please modify your current filter or add some shifts.`
  },
  CONFIRM_CHANGE_MODAL: {
    TITLE: `Confirm changes`,
    SUMMARY: `Are you sure you want to edit these shifts?`,
    ERROR_LOADING: `Shifts not found.`,
    CONFIRM_SHIFT_CHANGES_START: `Start changed from <0>{{ start }}</0> to <1>{{ oldStart }}</1>`,
    CONFIRM_SHIFT_CHANGES_END: `End changed from <0>{{ end }}</0> to <1>{{ oldEnd }}</1>`,
    CONFIRM_SHIFT_CHANGES_POSITION: `Position changed from <0>{{ oldPosition }}</0> to <1>{{ position }}</1>`,
    SEND_MODIFICATION: {
      LABEL: `Send modification notice`,
      DESCRIPTION: `This will send a modification notice to all published shifts.`
    }
  },
  CONFIRM_PASTE_MODAL: {
    TITLE: `Confirm pasting shifts`,
    SUMMARY: `Are you sure you want to paste these shifts?`,
    DESCRIPTION: `You are about to paste {{ count }} shift to the schedule.`,
    DESCRIPTION_other: `You are about to paste {{ count }} shifts to the schedule.`,
    DESCRIPTION_WITH_DATE: `You are about to paste {{ count }} shift on {{pasteDate}}.`,
    DESCRIPTION_WITH_DATE_other: `You are about to paste {{ count }} shifts on {{pasteDate}}.`,
    CLEAR_COPIED_EVENTS: `Clear copied events`
  },
  AUTOFILL_PROCEDURE_MODAL: {
    TITLE: `Choose Auto-fill procedure`,
    SUMMARY: ``,
    NO_PROCEDURE: `No procedure`,
    NO_PROCEDURE_WARNING: `There is no procedure included in the schedule. The shifts will be auto-filled without using any sort and filter.`
  },
  EDIT_MODAL: {
    TITLE: `Edit shift`,
    SUMMARY: ``,
    SHIFT: `Shift`,
    CONFIRMATION: `Confirmation Status`,
    HISTORY: `History`,
    SHIFT_NOT_CONFIRMED: `No shift notifications have been sent.`,
    TIMEOFF_NOT_CONFIRMED: `No time off notifications have been sent.`,
    EVENT_DELETED: `This shift has been deleted.`,
    EVENT_FINALIZED: `This shift is finalized and cannot be edited.`,
    SPECIFIC_RESTRICTIONS: `Specific restriction: {{  specificRestrictions }}`,
    SPECIFIC_RESTRICTIONS_other: `Specific restrictions: {{  specificRestrictions }}`,
    HISTORY_DIFFS: {
      CREATED: `<1>{{ time }}</1> on {{ date }} created by <0>{{ name }}</0>`,
      EDITED: `<1>{{ time }}</1> on {{ date }} edited by <0>{{ name }}</0>`,
      VIEWED_BY_USER: `<1>{{ time }}</1> {{ date }} viewed by <0>{{ name }}</0>`,
      START_CHANGED: `Start time changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
      END_CHANGED: `End time changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
      EMPLOYEEID_ASSIGNED: `<1>{{ after }}</1> was assigned to the shift`,
      EMPLOYEEID_UNASSIGNED: `<0>{{ before }}</0> was unassigned from the shift<1></1>`,
      EMPLOYEEID_CHANGED: `<1>{{ after }}</1> was assigned instead of <0>{{ before }}</0>`,
      POSITIONID_CHANGED: `Position was changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
      COMMENT_ADDED: `Comment was added: "<1>{{ after }}</1>"`,
      COMMENT_REMOVED: `Comment was removed: "<0>{{ before }}</0>"`,
      COMMENT_CHANGED: `Comment was changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
      UNFINALIZED: `Shift unfinalized`,
      FINALIZED: `Shift finalized`,
      UNRESOLVED: `Issues were unresolved`,
      RESOLVED: `Issues were resolved`,
      RESTORED: `Shift restored`,
      CANCELLED: `Shift cancelled`,
      PUBLISHED: `Shift published`,
      UNPUBLISHED: `Shift unpublished`,
      ADDED_TO_CONTACT_LIST: `Added to contact list`,
      ISEXTRASHIFT_CHANGED: `Is extra shift option changed`,
      ISOVERTIME_CHANGED: `Is overtime option changed`,
      ISONCALL_CHANGED: `Is onCall option changed`,
      ISIRREPLACEABLE_CHANGED: `Is irreplaceable option changed`,
      NEEDSREPLACEMENT_CHANGED: `Needs to be replaced option changed`,
      NOEMPLOYEEAVAILABLE_CHANGED: `No available employee option changed`,
      HASSPECIFICREQUIREMENTS_CHANGED: `Has specific requirements option changed`,
      COVEREDOTHERUNIT_CHANGED: `Covered by another unit option changed`,
      PROJECTS_CHANGED: `Projects changed`,
      DEPARTMENTS_CHANGED: `Departments changed`,
      BREAKS_CHANGED: `Breaks changed`,
      WAGEPREMIUMS_CHANGED: `Wage premiums changed`,
      REQUIREDATTRIBUTES_CHANGED: `Required attributes changed`,
      BILLINGDETAILS_CHANGED: `Billing details changed`,
      TAGS_CHANGED: `Tags changed`
    },
    CONFIRMATION_EVENTS: {
      CONFIRMATION: `Confirmation`,
      CANCELLATION: `Cancellation`,
      MODIFICATION: `Modification`,
      ACCEPTED_PHONE: `<0>{{ name }}</0> triggered a phone call at <1>{{ time }}</1> on {{ date }}.`,
      ACCEPTED_EMAIL: `<0>{{ name }}</0> triggered an email at <1>{{ time }}</1> on {{ date }}.`,
      CONFIRMED_PHONE: `Confirmed over the phone by the employee at <1>{{ time }}</1> on {{ date }}.`,
      CONFIRMED_EMAIL: `Confirmed by the employee at <1>{{ time }}</1> on {{ date }}.`,
      OPENED_EMAIL: `Email opened at <1>{{ time }}</1> on {{ date }}.`,
      DELIVERED_EMAIL: `Email delivered at <1>{{ time }}</1> on {{ date }}.`,
      FAILED_PHONE: `Phone failed at <1>{{ time }}</1> on {{ date }}.`,
      FAILED_EMAIL: `Email failed at <1>{{ time }}</1> on {{ date }}.`,
      NOPHONE_PHONE: `User had no phone number at <1>{{ time }}</1> on {{ date }}.`
    },
    CONFIRM_FOR_EMPLOYEE: `Confirm shift for employee`,
    REASON_FOR_CHANGE: `Reason for change: <0>{{ reason }}</0>`,
    REASON_FOR_CHANGE_DESCRIPTION: `Reason for change: <0>{{ reason }}</0>. Additional information: <1>{{ description }}</1>`,
    REASON_FOR_CREATION: `Reason for creation: <0>{{ description }}</0>`,
    USER_FLAGS: {
      ISHOLIDAY: `The shift starts or ends on a holiday: {{holidayNames}}.`,
      MISSING_PERMISSIONS: `You do no have permissions to view this issue.`,
      USER_IS_ELIGIBLE: 'User is eligible for the shift',
      USER_IS_NOT_ELIGIBLE: 'User is not eligible for the shift',
      SOLVE_PROBLEMS: 'Solve all eligibility issues.',
      COULD_NOT_GET_ISSUES: `Could not get the issues. A position is probably not selected.`,
      hasRestrictions_MISSING: `Employee has following restrictions: <0>{{ attributeNames }}</0>.`,
      missingSkills_MISSING: `Employee is missing following skills: <0>{{ attributeNames }}</0>.`,
      missingSkills_INFERIOR: `Employee skills are not a high enough level: <0>{{ attributeNames }}</0>.`,
      missingRequirements_MISSING: `Employee is missing following requirements: <0>{{ attributeNames }}</0>.`,
      missingRequirements_INFERIOR: `Employee requirements are not a high enough level: <0>{{ attributeNames }}</0>.`,
      missingRegion: `Wrong region, employee is not in <0>{{ missingRegions }}<0/>.`,
      leaveOverlapping: `Employee is absent.`,
      vacationOverlapping: `Employee is on <0>{{ type }}</0>. <1>({{ dateText }})</1>`,
      eventOverlapping: `Employee is already scheduled <0>{{ eventText }}</0> at <1>{{ positionName }}</1>.`,
      eventOverlapping_PROJECT: `Employee is already scheduled <0>{{ eventText }}</0> at <1>{{ positionName }}</1> on project <2>{{ projectName }}</2>.`,
      eventDistance: `This shift too close to another shift.`,
      lockedToProject: `Employee is locked to project <0>{{ projectName }}</0>.`,
      preferredOnProject: `Employee is preferred on project <0>{{ projectName }}</0>.`,
      maxNumberOfHours: `Employee already has <0>{{ numberOfHours }} hours</0> scheduled, maximum is <0>{{ maxHours }} hours</0>. <1>({{ hoursText }})</1>.`,
      maxNumberOfHoursPerDay: `Employee already has <0>{{ numberOfHours }} hours</0> scheduled, maximum is <0>{{ maxHours }} hours</0> per day.`,
      maxConsecutiveDays: `Employee would work <0>{{ numberOfConsecutiveDays }}</0> days in a row, maximum is <0>{{ maxConsecutiveDaysNumber }}</0>.`,
      missingPosition: `Employee cannot work on this position.`,
      unavailableAllDay: `Employee is unavailable all day.`,
      unavailableOverlap: `Employee is not available.`,
      noCurrentAvailability: `Employee has no current availability.`,
      pendingAvailability: `Employee has pending availability.`,
      wrongDepartment: `Employee not in this department.`,
      wrongTeam: `Employee not in this team.`,
      wrongProject: `Employee not in this project.`,
      maxConsecutiveTime: `Employee is working too many consecutive hours.`,
      missingAdjacentShiftBefore: `Employee is missing shift directly before.`,
      missingAdjacentShiftAfter: `Employee is missing shift directly after.`,
      missingAdjacentShifts: `Employee is missing adjacent shift.`,
      lockedToCurrent: `Employee is locked to current project.`,
      preferredOnCurrent: `Employee is preferred on current project.`,
      blockedFromProject: `Employee is blocked on current project.`,
      employeeExpiredContract: `Employee's contract is expired.`,
      employeeExpiredPermit: `Employee's permit is expired.`,
      expiredEmployeeType: `Employee's type expired.`,
      noContract: `Employee does not have a contract.`,
      noPermit: `Employee does not have a permit.`,
      noEmployeeType: `Employee is missing an employee type.`,
      beforeStartDate: `Employee is not yet available at this date.`,
      afterEndDate: `Employee is no longer available at this date.`,
      archivedUser: `Employee is archived.`,
      employeeTypeInvalid: `Does not have required hiring data`,
      userMightBeOnHoliday: `Employee might be on a holiday.`
    },
    USER_FLAGS_SHORT: {
      MISSING_PERMISSIONS: `You do no have permissions to view this issue.`,
      hasRestrictions: `Has restrictions`,
      missingSkills: `Missing skills`,
      missingRequirements: `Missing requirements`,
      missingRegion: `Wrong region`,
      leaveOverlapping: `Absent`,
      vacationOverlapping: `On time off`,
      vacationDuringWeek: `On time off during week`,
      eventOverlapping: `Already scheduled`,
      eventDistance: `Not enough time between shifts`,
      distanceNextShift_DETAIL: `Next shift {{ distanceNextShift}}h after`,
      distancePreviousShift_DETAIL: `Previous shift {{ distancePreviousShift }}h before`,
      lockedToProject: `Locked to another project`,
      preferredOnProject: `Preferred on another project`,
      totalProjectExperience_DETAIL: `Has {{ totalProjectExperience }}h of experience on project`,
      totalRelatedProjectExperience_DETAIL: `Has {{ totalProjectExperience }}h of related experience`,
      maxNumberOfHours: `Too many hours`,
      maxNumberOfHours_DETAIL: `<0>{{ numberOfHours }}/ {{ maxHours }}h</0> <1>({{ hoursText }})</1>`,
      maxNumberOfHoursPerDay: `Too many hours in one day`,
      maxConsecutiveDays: `Too many days in a row`,
      missingPosition: `Cannot work this position`,
      unavailableAllDay: `Unavailable all day`,
      unavailableOverlap: `Unavailable during part of shift`,
      noCurrentAvailability: `No current availability`,
      pendingAvailability: `Employee has pending availability`,
      wrongDepartment: `Not in department`,
      wrongTeam: `Not in team.`,
      wrongProject: `Not in project.`,
      maxConsecutiveTime: `Working too many consecutive hours`,
      missingAdjacentShiftBefore: `Missing shift directly before`,
      missingAdjacentShiftAfter: `Missing shift directly after`,
      missingAdjacentShifts: `Missing adjacent shift`,
      lockedToCurrent: `Locked to current project`,
      preferredOnCurrent: `Preferred on current project`,
      blockedFromProject: `Blocked on current project`,
      employeeExpiredContract: `Contract expired`,
      employeeExpiredPermit: `Permit expired`,
      expiredEmployeeType: `Type expired`,
      noContract: `No contract`,
      noPermit: `No permit`,
      noEmployeeType: `No employee type`,
      beforeStartDate: `Not started`,
      afterEndDate: `Already finished`,
      archivedUser: `Archived`,
      NO_AVAILABILITY: `Has no current availability`,
      employeeTypeInvalid: `Does not have required hiring data`,
      userMightBeOnHoliday: `Might be on a holiday`,
      isNotInWorkableHours: `Outside employment range`
    },
    LOAD_UNQUALIFIED_USERS: `Click here to see unqualified users`,
    ELIGIBLE: `Eligible`,
    NOT_ELIGIBLE: `Not eligible`,
    SHOW_ONLY_ELGIBLE_ATTRIBUTES_USERS_DESCRIPTION: `This section allows you to filter out users based on their eligibility for the shift.`,
    PROCEDUREID: {
      LABEL: `Procedure to use`,
      DESCRIPTION: `Used to determine how to filter and sort the employees.`
    }
  },
  CREATE_MODAL: {
    TITLE: `Create shift`,
    SUMMARY: ``
  },
  HISTORY_MODAL: {
    TITLE: `Shift information`,
    SUMMARY: ``
  },
  SELECTION_OPTIONS: {
    COPIED_COUNT: `{{ count }} copied`,
    COPIED_COUNT_other: `{{ count }} copied`,
    PASTE_COPIED_EVENTS: `Paste`,
    CLEAR_COPIED_EVENTS: `Clear copied shifts`,
    COPY_SELECTION: `Copy selection`,
    EVENTS_PASTED_SUCCESSFULLY: `Shifts pasted successfully`,
    AUTO_FILL_SELECTION: `Auto-fill selection`
  },
  VIEW_OPTIONS: {
    VIEW: 'View',
    DAILY: `Daily`,
    WEEKLY: `Weekly`,
    VIEW_OPTIONS: `Type of view`,
    ORGANISATION_OPTIONS: `Hierarchy`,
    RENDERING_OPTIONS: `View options`,
    HIERARCHY_PROJECTS: `By project`,
    HIERARCHY_POSITIONS: `By position`,
    HIERARCHY_USERS: `By user`,
    HIERARCHY_TEAMS: `By team`,
    HIDECONFIRMEDSHIFTINSCHEDULER: `Confirmation status`,
    HIDEPUBLISHEDSTATUSINSCHEDULER: `Publish status`,
    SHOWTEMPLATESHIFTINDICATIONINSCHEDULE: `Template status`,
    SHOWCANCELLEDSHIFT: `Cancelled shifts`,
    SHOWTIMEOFFINSCHEDULE: `Time off row in schedule`,
    SHOWABSENCESINSCHEDULE: `Absences row in schedule`,
    HIDESCHEDULESUMMARYROW: `Schedule summary row`,
    HIDESCHEDULESUMMARYCOLUMN: `Schedule summary column`,
    HIDEEMPTYSCHEDULERROWS: `Empty rows`,
    HIDECUSTOMCOLORS: `Custom colors`,
    OPTIONS: `Options`
  },
  TOOLS: {
    IMPORT: `Import`,
    TOOLS: `Tools`,
    APPLY_TEMPLATE: `Apply a schedule template`,
    EXPORT: `Export`,
    DAILY_REPORT_PDF: `Daily schedule (PDF)`,
    WEEKLY_REPORT_EMPLOYEE_PDF: `By employee (PDF)`,
    WEEKLY_REPORT_POSITION_PDF: `By position (PDF)`,
    DAILY_REPORT_CSV: `Daily schedule (CSV)`,
    SCHEDULE_RAW_CSV: `Raw schedule (CSV)`,
    SYNC_SCHEDULE: `Sync the schedule`,
    SYNC_PUNCHES: `Sync punches to shifts`,
    SHIFT_PUBLICATION: `Publish whole schedule`,
    QUICK_ASSIGN: `Quick assign`
  },
  CHANGE_REASONS: {
    NO_REASON: `No reason (skip)`,
    CHANGED_HOURS: `Changed shift hours`,
    CHANGED_ASSIGNED_EMPLOYEE: `Changed assigned employee`,
    CANCELLATION: `Shift was cancelled`,
    OTHERS: `Other (see description)`,
    HASRESTRICTIONS: `Employee had restrictions`,
    MISSINGSKILLS: `Employee was missing skills`,
    MISSINGREQUIREMENTS: `Employee was missing requirements`,
    MISSINGREGION: `Employee was not in region`,
    VACATIONOVERLAPPING: `Employee was on time off`,
    EVENTOVERLAPPING: `Employee was already scheduled`,
    EVENTDISTANCE: `Employee had a shift too close`,
    LOCKEDTOPROJECT: `Employee was locked to project`,
    PREFERREDONPROJECT: `Employee was preferred on project`,
    MAXNUMBEROFHOURS: `Employee was over maximum number of hours`,
    MAXNUMBEROFHOURSPERDAY: `Employee was over maximum number of hours per day`,
    MAXCONSECUTIVEDAYS: `Employee was over maximum number of days in a row`,
    MISSINGPOSITION: `Employee could not work on that position`,
    LEAVEOVERLAPPING: `Employee was absent`,
    UNAVAILABLEALLDAY: `Employee was unavailable all day`,
    UNAVAILABLEOVERLAP: `Employee was unavailable during shift`,
    PENDINGAVAILABILITY: `Employee had pending availability`,
    WRONGDEPARTMENT: `Employee was not in department`,
    WRONGTEAM: `Employee was not in team`,
    WRONGPROJECT: `Employee was not in project`,
    MAXCONSECUTIVETIME: `Employee was working too many consecutive hours`,
    MISSINGADJACENTSHIFTBEFORE: `Employee was missing a shift before`,
    MISSINGADJACENTSHIFTAFTER: `Employee was missing a shift after`,
    MISSINGADJACENTSHIFTS: `Employee was missing an adjacent shift`,
    LOCKEDTOCURRENT: `Employee was locked to current project`,
    PREFERREDONCURRENT: `Employee was preferred on project`,
    BLOCKEDFROMPROJECT: `Employee was blocked from project`,
    EMPLOYEEEXPIREDCONTRACT: `Employee had an expired contract`,
    EMPLOYEEEXPIREDPERMIT: `Employee had an expired permit`,
    EXPIREDEMPLOYEETYPE: `Employee had an expired employee type`,
    NOCONTRACT: `Employee had no contract`,
    NOPERMIT: `Employee had no permit`,
    NOEMPLOYEETYPE: `Employee had no type`,
    BEFORESTARTDATE: `Employee had not started yet`,
    AFTERENDDATE: `Employee was scheduled after end date`,
    ARCHIVEDUSER: `Employee was archived`,
    RESTORATION: 'Shift was restored',
    IMPORT: {
      CERIDIAN_PUNCH_SYNC: `Synced using ceridian punch cards`
    }
  },
  eventForm: {
    ERROR_LOADING_FLAGS: `Error loading employee eligibility.`,
    OTHER_INFO: `Other info`,
    SHIFT_OPTIONS: `Shift options`,
    ELIGIBLE_POSITION: `This position is not required for the assigned project.`,
    REPLACE: `Replace`,
    REMOVE: `Remove`,
    ADD: `Add`,
    SELECTEDSCHEDULETYPE: {
      LABEL: `Schedule type`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Helps you quickly select a pre-determined start and end time for the shift.`
    },
    CUSTOM_SCHEDULE_TYPE: `Custom`,
    TIME_CHANGED_RECALCULATE_BREAKS: `Click here to re-calculate breaks, start or end time has been changed.`,
    MULTIPLE_VALUES: `Multiple values`,
    CLICK_TO_EDIT: `Click to edit`,
    EMPLOYEEID: {
      LABEL: `User`,
      PLACEHOLDER: `Unassigned`,
      DESCRIPTION: `Used to assign an user to a shift, leave empty to create an unassigned shift.`
    },
    POSITIONID: {
      LABEL: `Position`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Used to assign a shift to a position.`
    },
    START: {
      LABEL: `Start time`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    END: {
      LABEL: `End time`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    STARTDATE: {
      LABEL: `Date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If the end time is before the start, the shift will automatically go overnight.`
    },
    COMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Add notes or instructions for the employee.`,
      DESCRIPTION: `Comments can add information to shifts, they are shown to all users that can see the shift. This field supports translations using #fr and #en.`
    },
    ISEXTRASHIFT: {
      LABEL: `Variable end time`,
      DESCRIPTION: `Used to indicate that this shift has no set end time, will prevent users from seeing when the shift ends.`
    },
    ISOVERTIME: {
      LABEL: `Overtime shift`,
      DESCRIPTION: `Used to indicate that this is an overtime shift. Can be used to ignore certain scheduling issues.`
    },
    ISONCALL: {
      LABEL: `On call shift`,
      DESCRIPTION: `Used to indicate that this is an on call shift. It won't be taken into account in the total hours assigned to the employee.`
    },
    ISIRREPLACEABLE: {
      LABEL: `Should not be replaced`,
      DESCRIPTION: `Used to indicate that the user on this shift should not be replaced.`
    },
    NEEDSREPLACEMENT: {
      LABEL: `Needs to be replaced`,
      DESCRIPTION: `Used to indicate that the user on this shift needs to be replaced.`
    },
    NOEMPLOYEEAVAILABLE: {
      LABEL: `No employee available`,
      DESCRIPTION: `Used to indicate that an unassigned shift did not have anyone eligible for it.`
    },
    HASSPECIFICREQUIREMENTS: {
      LABEL: `Has specific requirements`,
      DESCRIPTION: `Used to indicate that a shift has specific requirements that might be noted in the shift comment.`
    },
    COVEREDOTHERUNIT: {
      LABEL: `Covered by another unit`,
      DESCRIPTION: `Used to indicate that a shift does not need to be filled as it has been covered by another business unit.`
    },
    PROJECTS: {
      LABEL: `Projects`,
      PLACEHOLDER: `Assign this shift to a project`,
      DESCRIPTION: `Used to assign a shift directly to a project.`
    },
    TEAM: {
      LABEL: `Team`,
      PLACEHOLDER: `Assign this shift to a team`,
      DESCRIPTION: ``
    },
    TAGS: {
      LABEL: `Tags`,
      PLACEHOLDER: `Assign tags to this shift`,
      DESCRIPTION: `Used to assign tags such as locations, clients or wage premiums to a shift.`
    },
    CHANGEREASON: {
      LABEL: `Reason for the change (optionnal)`,
      DESCRIPTION: `Used to help explain the reason for a change in the shift history. `
    },
    CHANGEDESCRIPTION: {
      LABEL: `Change description`,
      PLACEHOLDER: `Add a description if the pre-loaded options don't help explain the change.`,
      DESCRIPTION: `Used to add more details to the reason for the change in the shift history.`
    },
    CREATIONDESCRIPTION: {
      LABEL: `Creation description`,
      PLACEHOLDER: `Add a description if you need to explain why this shift was created.`,
      DESCRIPTION: `Used to add more details in the shift history.`
    },
    UPDATEFUTURERECURRENCE: {
      LABEL: `Update all future shifts in this recurrence`,
      DESCRIPTION: `If unchecked, only the current shift will be updated.`
    },
    BREAKS: {
      TITLE: `Breaks`,
      LABEL: `Breaks`,
      SUMMARY: `Add paid and unpaid breaks to the shift`,
      DESCRIPTION: `Add paid and unpaid breaks to the shift`,
      RECALCULATE_BREAKS: `Recalculate breaks`,
      CUSTOM: `Custom break`,
      CUSTOM_NAME: `Break {{ index }}`,
      ADD_BREAK: 'Add break'
    },
    BREAKNAME: {
      LABEL: `Break name`,
      PLACEHOLDER: `Add a descriptive name for the break`,
      DESCRIPTION: `Used to help quickly identify what type of break this is.`
    },
    BREAKDURATION: {
      LABEL: `Break Duration`,
      PLACEHOLDER: `Add a duration for the break`,
      DESCRIPTION: `Duration in minutes of the break`
    },
    BREAKPAID: {
      LABEL: `Paid break`,
      DESCRIPTION: ``
    },
    MULTI_CREATION: `Create multiple`,
    DUPLICATENUMBER: {
      LABEL: `Number of identical shifts`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Used to create multiple identical shifts, if 5 is entered above, 5 identical shifts will be added to the template rather than one.`
    },
    ADDTOOTHERDAYS: {
      LABEL: `Add to other days`,
      DESCRIPTION: `Used to create similar shifts on multiple days, can be combined with number of identical shifts to create multiple identical shifts on multiple days.`
    },
    WAGEPREMIUMS: {
      TITLE: `Wage premiums`,
      LABEL: `Wage premiums`,
      SUMMARY: `Apply wage modifiers to the shift`,
      DESCRIPTION: `Apply wage modifiers to the shift`,
      ADD_WAGE_PREMIUM: `Add a premium`,
      SHIFT_DURATION: `shift duration`
    },
    WAGEPREMIUMFULLSHIFT: {
      LABEL: `Apply to full shift`,
      DESCRIPTION: ``
    },
    WAGEPREMIUMOVERRIDEOVERTIME: {
      LABEL: `Disable automatic overtime calculation for this employee's entire week`,
      DESCRIPTION: `Overtime wage premiums will have to be manually added for this card as well as any punch cards in the same week.`
    },
    WAGEPREMIUMHOURS: {
      LABEL: `Amount`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Amount of hours to apply this wage premium to. Use decimal notation, for example an hour and fifteen minutes would be written "1.25".`
    },
    WAGEPREMIUMUNITS: {
      LABEL: `Amount`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Amount of units to apply this wage premium to.`,
      UNITS: `units`
    },
    WAGEPREMIUMS_NOT_CONFIGURED: {
      DESCRIPTION: `No wage premiums configured`,
      LINK: `Manage wage premiums here`
    },
    WAGE_PREMIUM_FULL_SHIFT_CALCULATED_ON_SUBMIT: 'The amount of this wage premium is calculated when submitting the punch card.',
    REQUIREDATTRIBUTES: {
      TITLE: `Required attributes`,
      LABEL: `Required attributes`,
      DESCRIPTION: `Add additionnal specific attributes to this shift.`
    },
    SENDMODIFICATIONCANCELLATIONEMAILS: {
      LABEL: `Send modification/cancellation notice`,
      DESCRIPTION: `A modification notice will be sent to the assigned employee if important informations have been changed (Start time, End time, Date, Position, Projects or comment). A cancellation notice will be sent to the employee being unassigned from the shift.`
    },
    SENDNOTIFICATIONFORNEWEMPLOYEE: {
      LABEL: `Send notice to newly assigned employee`,
      DESCRIPTION: `A notice will be sent to the newly assigned employee.`
    }
  },
  reports: {
    CSV_FORMATTED_REPORT_TITLE: `csv_daily_report_{{ date }}`,
    CSV_REPORT_RAW_TITLE: `csv_raw_report_{{ start }}-{{ end }}`,
    PDF_DAILY_REPORT_TITLE: `pdf_daily_report_{{ date }}`,
    PDF_WEEKLY_REPORT_TITLE: `pdf_weekly_report_{{ start }}-{{ end }}`,
    DAILY_REPORT_LEGEND: `(R;L: Late / A: Absent / V: Time off)`,
    GENERATED_BY: `Generated by`,
    PRIORITY: `Priority`,
    SENIORITY: `Seniority`,
    EMPLOYEE_NUMBER: `Employee number`,
    FIRSTNAME: `First name`,
    LASTNAME: `Last name`,
    PRIMARY_OCCUPATION: `Primary occupation`,
    POSITION: `Position`,
    START: `Start time`,
    END: `End time`,
    STATUS: `Employment status`,
    HOURS_WORKED: `Hours worked`,
    HOURS_PLANNED: `Hours planned`,
    LOCATION_TAGS: `Locations`,
    REGION: `Regions`,
    CLIENT_TAGS: `Clients`,
    RESOURCE_TAGS: `Resources`,
    IRREPLACEABLE: `Is irreplaceable`,
    NEEDSREPLACEMENT: `Needs to be replaced`,
    COVEREDOTHERUNIT: `Covered by another unit`,
    VARIABLE_END_TIME: `Variable end time`,
    OVERTIME: `Overtime`,
    ISONCALL: `On call`,
    NO_EMPLOYEE_AVAILABLE: `No employee available`,
    HAS_SPECIFIC_REQUIREMENTS: `Has specific requirements`,
    COMMENT: `Comment`,
    PROJECT: `Project name`,
    PROJECT_CODE: `Project code`,
    PROJECT_OWNERS: `Project owners`,
    LOCKED_TO: `Locked to (projects)`,
    PREFERRED_ON: `Preferred on (projects)`,
    BLOCKED_FROM: `Blocked on (projects)`,
    EMPLOYEE: `Employee`,
    SHIFTS: `Shifts`,
    HOURS_MSG: `Hours`,
    TAGS: `Tags`,
    UNASSIGNED: `Unassigned shift`,
    SCHEDULE_HEADER_WEEKLY: `Schedule from {{ start }} to {{ end }}`,
    ALL_DAY: `All-day`,
    TIME_OFF: `Time off`
  },
  SEND_CANCELLATION_NOTICE: `A cancellation notice will be sent to all affected employees.`,
  CONTEXT_MENU: {
    NO_OPTIONS: `No options`,
    CONFIRMED_IN_PERSON: `Confirmed in person`,
    FINALIZE: `Finalize`,
    UNFINALIZE: `Unfinalize`,
    PUBLISH: `Publish`,
    UNPUBLISH: `Unpublish`,
    DELETE: `Delete`,
    CANCEL: `Cancel`,
    COPY: `Copy`,
    PASTE: `Paste`,
    COPY_SELECTION: `Copy selected`,
    RESTORE_SHIFT: `Restore`,
    UNASSIGN_EMPLOYEE: `Unassign employee`,
    UNASSIGN_EMPLOYEES: `Unassign employees`,
    CREATE_LEAVE: `Create attendance request`,
    OPEN_THE_USER_SCHEDULE: `View in user's schedule`,
    OPEN_THE_SHIFT_CONTACT_LIST: `Related contact list`,
    OPEN_THE_SHIFT_TEMPLATE: `Related schedule template`,
    OPEN_THE_SHIFT_CONTACT_LIST_MOBILE: `Open related contact list`,
    OPEN_THE_SHIFT_TEMPLATE_MOBILE: `Open related schedule template`,
    CREATE_LIST: `Replace this shift (list)`,
    SEND_CONFIRMATIONS: `Send notifications`,
    SEND_TIMEOFF_NOTIFICATION: `Send time off notification`,
    SEND_SHIFT_NOTIFICATION: `Send shift notification`,
    EDIT_SELECTED: `Edit selected`,
    EDIT_SHIFT: `Edit`,
    DELETE_SELECTED: `Delete selected`,
    FINALIZE_SELECTED: `Finalize selected`,
    UNFINALIZE_SELECTED: `Unfinalize selected`,
    PUBLISH_SELECTED: `Publish selected`,
    UNPUBLISH_SELECTED: `Unpublish selected`,
    CANCEL_SELECTED: `Cancel selected`,
    RESTORE_SELECTED: `Restore selected`,
    CREATE_LIST_SELECTED: `Replace these shifts (list)`,
    CREATE_PUNCHCARD: `Create punch card`,
    SELECT_SHIFTS: `Select shifts`,
    SELECTED: `{{ count }} shift selected`,
    SELECTED_other: `{{ count }} shifts selected`,
    SELECTED_TIMEOFF: `{{ count }} time off selected`,
    SELECTED_TIMEOFF_other: `{{ count }} time offs selected`,
    OPEN_PUNCH_CARD: `Punch card`,
    OPEN_TIME_OFF: `Time off request`,
    OPEN_COMMENTS: `Comments`,
    OPEN_ATTENDANCE: `Attendance request`,
    OPEN_PUNCH_CARD_MOBILE: `Open punch card`,
    OPEN_TIME_OFF_MOBILE: `Open time off request`,
    OPEN_ATTENDANCE_MOBILE: `Open attendance request`,
    OPEN_USER: `Employee profile`,
    OPEN_USER_SCHEDULE: `Employee Schedule`,
    OPEN: `Open`,
    ADVANCED: `Advanced`,
    USER_INFO: `Employee info`,
    SEE: `Open`
  },
  FINALIZE: {
    TITLE: `Finalize these shifts`,
    SUMMARY: `Are you sure you want to finalize these shifts?`,
    DESCRIPTION: `Finalizing a shift will prevent editing until it has been unfinalized.`,
    ERROR_LOADING: `One or more of the shifts that you were attempting to finalize were deleted.`
  },
  UNFINALIZE: {
    TITLE: `Unfinalize these shifts`,
    SUMMARY: `Are you sure you want to unfinalize these shifts?`,
    DESCRIPTION: `Unfinalizing a shift will allow editing until it is finalized.`,
    ERROR_LOADING: `One or more of the shifts that you were attempting to unfinalize were deleted.`
  },
  DELETE_MODAL: {
    TITLE: `Delete these shifts`,
    SUMMARY: `Are you sure you want to delete these shifts?`,
    DESCRIPTION: `Deleting a shift is permanent and all edit history will be lost.`,
    PUNCHCARDS_ASSOCIATED: `One or more of the shifts that you are attempting to delete have a punch card associated.`,
    SENDCANCELLATIONEMAILS: {
      LABEL: `Send cancellation notice`,
      DESCRIPTION: `This will send a cancellation notice to all assigned employees.`
    },
    DELETEFUTURERECURRENCE: {
      LABEL: `Delete recurrence`,
      DESCRIPTION: `This will delete all future shifts in this recurrence.`
    },
    DELETEEVENTSWITHPUNCHCARDS: `Delete Shifts with Punch Cards associated`
  },
  UNASSIGN_EMPLOYEE_MODAL: {
    TITLE: `Unassign employees`,
    SUMMARY: `Are you sure you want to unassign the employees from these shifts?`,
    ERROR_LOADING: `One or more of the shifts you were attempting to unassign the employee of were deleted.`
  },
  CANCEL_MODAL: {
    TITLE: `Cancel these shifts`,
    SUMMARY: `Are you sure you want to cancel these shifts?`,
    DESCRIPTION: `Once cancelled, shifts do not appear in any reports. Cancelling is similar to deleting except that it is reversable and a history is kept.`,
    UNASSIGN_EMPLOYEE: `Unassign employee`,
    CANCEL_SHIFT: `Cancel shift`,
    ERROR_LOADING: `One or more of the shifts that you were attempting to cancel were deleted.`,
    CANCELEMPLOYEE: {
      LABEL: `Select action`,
      DESCRIPTION: `Unassigning the employee will leave the shift on the schedule, cancelling the shift will remove it from the schedule and any reports.`
    },
    CANCELFUTURERECURRENCE: {
      LABEL: `Cancel recurrence`,
      DESCRIPTION: `This will cancel all future shifts of this recurrence.`
    },
    SENDCANCELLATIONEMAILS: {
      LABEL: `Send cancellation notice`,
      DESCRIPTION: `This will send a cancellation notice only to employees assigned to a published shift.`
    },
    CANCELLATIONCOMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Add a comment`,
      DESCRIPTION: `This comment will be added to the notice sent to employees`
    },
    REASON: {
      LABEL: `Reason for cancellation`,
      PLACEHOLDER: `Add a reason for cancellation`,
      DESCRIPTION: `Used to help explain the reason for a change in the shift history.`
    }
  },
  RESTORE_MODAL: {
    TITLE: `Restore these shifts`,
    SUMMARY: `Are you sure you want to restore these shifts?`,
    DESCRIPTION: `Once restored, shifts will reappear in the schedule.`,
    SENDCONFIRMATIONEMAILS: {
      LABEL: `Send notifications`,
      DESCRIPTION: `This will send notifications to all assigned employees.`
    },
    RESTORATIONCOMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Add a comment`,
      DESCRIPTION: `This comment will be added to the notice sent to employees`
    },
    REASON: {
      LABEL: `Reason for restoring`,
      PLACEHOLDER: `Add a reason for restoring the shift`,
      DESCRIPTION: `Used to help explain the reason for a change in the shift history.`
    }
  },

  PUBLISH_MODAL: {
    TITLE: `Confirm shifts and time off`,
    SUMMARY: `Are you sure you want to publish these shifts and time off?`,
    DESCRIPTION: ``,
    ERROR_LOADING: `Error loading shifts or time off`,
    EVENTS_TO_CONFIRM: `Shifts`,
    TIMEOFF_TO_CONFIRM: `Time off`,
    EVENTS: `Shifts`,
    TIMEOFFS: `Time off`,
    ALERT_CONFIRM_SHIFTS: `A notification will be sent to all employees assigned to the selected shifts.`,
    ALERT_CONFIRM_TIMEOFFS: `A notification of time off will be sent to all employees affected.`,
    CONFIRM: {
      LABEL: `Send a notification`,
      DESCRIPTION: `Used to send a notification by email and push notification to all assigned enployees.`
    },
    RECONFIRM: {
      LABEL: `Re-notify all`,
      DESCRIPTION: `Used to re-send a notification to all employees, even those that have already received one.`
    },
    PHONECONFIRM: {
      LABEL: `Send a notification`,
      DESCRIPTION: `Used to send a notification by phone and push notification to all assigned employees.`
    },
    RECONFIRMUNCONFIRMED: {
      LABEL: `Re-notify unconfirmed`,
      DESCRIPTION: `Used to re-send a notification to all employees that have not confirmed their shifts or time off.`
    },
    CUSTOMMESSAGE: {
      LABEL: `Custom message`,
      PLACEHOLDER: `Add a custom message`,
      DESCRIPTION: `Used to add a custom message to phone notifications, this message must be in a single language.`
    },
    CONFIRMTIMEOFF: {
      LABEL: `Send a notification of time off`,
      DESCRIPTION: `Used to send a notification of time off by email and push notification to all selected people on time off.`
    },
    RANGE_TO_PUBLISH: {
      LABEL: `Range to publish`,
      DESCRIPTION: `Used to publish a different or larger range than initially selected.`
    }
  },
  PUBLISH: {
    TITLE: `Publish`,
    SUMMARY: `Are you sure you want to publish these shifts/time offs?`,
    ALERT: `Employees assigned to these shifts will see them appear in their schedule.`,
    ERROR_LOADING: `One or more of the shifts that you were attempting to publish were deleted.`
  },
  UNPUBLISH: {
    TITLE: `Unpublish these shifts`,
    SUMMARY: `Are you sure you want to unpublish these shifts?`,
    ALERT: `Employees assigned to these shifts will no longer see them in their schedule.`,
    ERROR_LOADING: `One or more of the shifts that you were attempting to unpublish were deleted.`
  },
  CONFIRM: {
    TITLE: `Send a time off notification`,
    SUMMARY: `Are you sure you want to send a time off notification to all affected employees?`,
    ERROR_LOADING: `One or more of the time offs that you were attempting to send a notification for were deleted.`
  },
  CONFIRM_SHIFT: {
    TITLE: `Send a shift notification`,
    SUMMARY: `Are you sure you want to send a shift notification to all affected employees?`,
    ERROR_LOADING: `One or more of the shifts that you were attempting to send a notification for were deleted.`
  },
  FIX_USER_ELIGIBILITY_PROBLEMS_MODAL: {
    TITLE: `Solve {{name}}'s eligibility problems`,
    SUMMARY: 'What do you want to update/add?',
    POSITION: `Position`,
    ATTRIBUTES: `Attributes`,
    REGIONS: `Regions`,
    DEPARTMENT: `Departements`,
    PROJECT: `Project`,
    STATUS: `Status`,
    TEAM: `Team`,
    MAKE_ACTIVE: `Change user status for "active"`
  },
  MULTI_EDIT_MODAL: {
    TITLE: `Edit multiple shifts`,
    SUMMARY: ``,
    SENDMODIFICATIONCANCELLATIONEMAILS: {
      LABEL: `Send modification/cancellation notice`,
      DESCRIPTION: `A modification notice will be sent to the assigned employees if important informations have been changed (Start time, End time, Date, Position, Projects or comment). A cancellation notice will be sent to the employees being unassigned from the shifts.`
    }
  },
  SCHEDULE_TEMPLATE_APPLY_MODAL: {
    TITLE: `Apply a schedule template`,
    SUMMARY: ``,
    DESCRIPTION: `Clicking on submit will apply the template to every visible day, it will not update shifts that already belong to this template.`,
    SCHEDULETEMPLATEID: {
      LABEL: `Schedule template to apply`,
      DESCRIPTION: `Select a schedule template to apply to the current visible dates.`
    }
  },
  SCHEDULE_ASSIGN_EMPLOYEE_MODAL: {
    TITLE: `Edit shift`,
    SUMMARY: ``,
    SENDNOTIFICATIONFORNEWEMPLOYEE: {
      LABEL: `Send notice to newly assigned employee`,
      DESCRIPTION: `A notice will be sent to the newly assigned employee.`
    },
    SENDCANCELLATIONEMAILS: {
      LABEL: `Send cancellation notice`,
      DESCRIPTION: `A cancellation notice will be sent to the employee being unassigned from the shift.`
    },
    SEND_CANCELLATION_NOTICE: `A cancellation notice will be sent to the empoyee being unassigned from the shift.`,
    ALERT_CONFIRM_SHIFTS: `A notice will be sent to the employee newly assigned to the shift.`,
    SHIFT_IN_LIST_WARNING: `A shift or several shifts are currently in a contact list, assigning a new user to these shifts will make them unavailable in that list.`
  },
  import: {
    TITLE: {
      TITLE: `Import event`,
      SUMMARY: ``
    },
    LINE: `Line`,
    EMPLOYEE_NUMBER: `Employee number`,
    EMPLOYEENUMBER_DESC: `The employee number found in the employee file in Merinio.`,
    POSITION_CODE: `Position code`,
    POSITIONCODE_DESC: `Must be a position code as chosen by your administrator.`,
    PROJECTCODE: `Project code`,
    PROJECTCODE_DESC: `Must be an existing project code as chosen by your administrator.`,
    WAGEPREMIUMS: `Wage premium`,
    WAGEPREMIUMS_DESC: `Must be in the format <1>earningCode:amount</1>, where a wage premium with earning code <1>ABC</1> and amount of <1>1</1> would be imported as <1>ABC:1</1>. It must be an earning code as chosen by your administrator. To enter more than one wage premium, leave a space between each code, for example: <1>ABC:1</1> <1>DCE:2</1>`,
    STARTDATE: `Date`,
    STARTDATE_DESC: `Date in <1>YYYY-MM-DD</1> format, for example January 30th 2010 would be <1>2010-01-30</1>.`,
    STARTTIME: `Start`,
    STARTTIME_DESC: `Start time in <1>HH:mm</1> format, for example 4PM would be <1>16:00</1>.`,
    ENDTIME: `End`,
    ENDTIME_DESC: `End in the same format as start.`,
    COMMENT: `Comment`,
    COMMENT_DESC: `Adds a comment to the shift when filled.`,
    TAGS: `Tags`,
    TAGS_DESC: `Must be an existing tag as chosen by your administrator. To enter more than one value leave a space between each code.`,
    DAYINTEMPLATE: `Day in template`,
    DAYINTEMPLATE_DESC: `If the template is multi-day, this is a number corresponding to the day that the shift will be added to. If empty, the shift will be added to the first day of the template. <1>1</1> is the first day, <1>2</1> is the second day, etc.`,
    ISEXTRASHIFT: `Variable end time`,
    ISEXTRASHIFT_DESC: `Indicates whether this shift has a variable end time or not. Inserting a '<0>X</0>' in the cell means <0>YES</0>, leaving in empty means <0>NO</0>. `,
    ISOVERTIME: `Is Overtime`,
    ISOVERTIME_DESC: `Indicates whether this shift is overtime or not (Same instructions as <0>isExtraShift</0>).`,
    SONCALL: `Is on call`,
    ISONCALL_DESC: `Indicates whether this shift is on call or not (Same instructions as <0>isExtraShift</0>).`,
    NONBILLABLE: `Non billable`,
    NONBILLABLE_DESC: `Indicates whether this shift is non billable (Same instructions as <0>isExtraShift</0>).`,
    ISIRREPLACEABLE: `Should not be replaced`,
    ISIRREPLACEABLE_DESC: `Indicates that this shift should not be replaced (Same instructions as <0>isExtraShift</0>).`,
    NEEDSREPLACEMENT: `Needs to be replaced`,
    NEEDSREPLACEMENT_DESC: `Indicates that this shift needs to be replaced (Same instructions as <0>isExtraShift</0>).`,
    NOEMPLOYEEAVAILABLE: `No employee available`,
    NOEMPLOYEEAVAILABLE_DESC: `Indicates that this shift has no employees available (Same instructions as <0>isExtraShift</0>).`,
    HASSPECIFICREQUIREMENTS: `Has specific requirements`,
    HASSPECIFICREQUIREMENTS_DESC: `Indicates that this shift has specific requirements (Same instructions as <0>isExtraShift</0>).`,
    COVEREDOTHERUNIT: `Covered by another unit`,
    COVEREDOTHERUNIT_DESC: `Indicates that this shift will be covered by another business unit (Same instructions as <0>isExtraShift</0>).`,
    DELETE: `Delete`,
    DELETE_DESC: `If an event matches the start / end / employee of this event, it will be selected for deletion (Same instructions as <0>isExtraShift</0>).`,
    DOWNLOAD_TEMPLATE: `Download template`,
    MISSING_HEADERS: `Missing the following header: <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Missing the following headers: <0>{{value}}</0>`,
    TEMPLATE_FILE_NAME: `shift_import_template`,
    SHIFTS_SAVING_FAILED: `There was <0>{{count}}</0> shift that were not saved.`,
    SHIFTS_SAVING_FAILED_other: `There were <0>{{count}}</0> shifts that were not saved.`,
    SHIFTS_NOT_VALID: `There was <0>{{count}}</0> invalid shift.`,
    SHIFTS_NOT_VALID_other: `There was <0>{{count}}</0> invalid shifts.`,
    INVALID_TEMPLATE: `Invalid template.`,
    FULL_SHIFT: `full shift`,
    VALIDATION: `Validation`
  },
  SHIFT_MORE_THEN_16HOURS: `The shift is currently longer than 16 hours.`,
  PUNCH_ARRIVAL: `Arrival time: {{time}}`,
  PUNCH_LEAVE: `Departure time: {{time}}`,
  CREATE_ATTENDANCE: {
    TITLE: `Create an attendance request`,
    SUMMARY: `This allows you to quickly create an attandance request for an employee.`
  },
  CANT_DROP_ON_PROJECT: `You can't assign a shift to a project.`,
  CANT_DROP_ON_TEAM: `You can't assign a shift to a team.`,
  CANT_DROP_ON_TIME_OFF: `You can't assign a shift to a time off.`,
  CANT_DROP_ON_ABSENCE: `You can't assign a shift to an absence.`,
  CANT_DROP_ON_NON_ASSIGNABLE_POSITION: `You can't assign a shift to a non-assignable position.`,
  TOO_MUCH_IDENTICAL_SHIFT: `You can't create more than {{number}} identical shifts at once, to create more that that please do so in batches of {{number}}.`,
  DATE_TOO_FAR: `You can't create a recurrence for more than 2 years.`,
  QUICK_ASSIGN: {
    TITLE: `Quick assign`,
    SUMMARY: `This tool allows you to see which users are available based on specified filters and then to add them to the schedule.`,
    PRIMARY_ACTION: `Create shifts`,
    CREATE_TIME_OFF: `Create time off requests`,
    EXPORT_SELECTION: `Export selection`
  },
  LEGEND: {
    TITLE: `Legend`,
    SHIFT_SECTION_TITLE: `Shift status`,
    SHORTCUTS_SECTION_TITLE: `Keyboard shortcuts`,
    SHIFT_STATE: {
      PUBLISHED: `Published shift`,
      NOTIFIED: `Notified shift`,
      CONFIRMED: `Confirmed shift`,
      COMMENTED: `Comment(s)`,
      LOCKED: `Locked shift`,
      CONTACTLIST: `Contacts list`
    },
    PUNCH_IN: `Punch in`,
    PUNCH_OUT: `Punch out`,
    OPENED_NOTIF: `Opened Notification`,
    ABSENCE_REASONS: {
      ABSENT: `Absent`,
      LATE_EARLY_OUT: `Late/Early out`,
      TIME_OFF: `Time off`,
      REPLACEMENT: `Replacement`
    },
    SELECTED_SHIFT: `Selected shift`,
    UNASSIGNED_SHIFT: `Unassigned shift`,
    UNASSIGNED_SHIFT_SAMPLE: `Unassigned`,
    UNASSIGNED_SHIFT_TAGS: {
      ACTION_REQUIRED: `Needs to be replaced`,
      NO_ACTIONS: `No employee available / Covered by other unit`
    },
    ATENTION_MENTIONNED: `Should not be replaced / Has specific requirements`,
    PAY_AFFECT: {
      OVER_TIME: `Overtime`,
      ON_CALL: `On call`
    },
    SHORTCUT_ACTIONS: {
      SELECT_ALL: `Select all shifts`,
      SELECT_SOME: `Select shifts by clicks`,
      SELECT_MANY: `Select shifts with the rectangle selection tool`,
      COPY: `Copy selected shifts`,
      PASTE: `Paste selected shifts`,
      FILTER_NAV: `Select filters using arrows`,
      ADD_FILTER: `Attach or unlink filter`,
      ESCAPE: `Close dropdown menu`,
      SEARCH: `Initiate search fonction`
    },
    SHIFT_SAMPLE: {
      ABSENT: `Is absent`,
      LATE_EARLY_OUT: `Arrived at 10:00`,
      TIME_OFF: `On time off`,
      ACTION_REQUIRED: `Needs to be replaced`,
      NO_ACTIONS: `No employee available`,
      ATENTION_MENTIONNED: `Should not be replaced`,
      OVER_TIME: `Overtime`,
      ON_CALL: `On call`
    }
  },
  REQUIRED_FIELD: `This field is mandatory.`,
  PUBLISHED_STATUS: {
    PUBLISHED_COUNT: `{{publishedCount}}/{{totalCount}} published`,
    PUBLISH_ALL: `Publish whole schedule`,
    FILTER_UNPUBLISHED: `Show only unpublished shifts`,
    SEND_SHIFT_NOTIFICATION: `Send notifications to published shifts`
  },
  UNAVAILABLE_STATUS: {
    UNAVAILABLE_COUNT: `{{ count }} absent/on time off`,
    UNASSIGN_ALL: `Unassign all absent/on time off shifts`
  },
  EMPLOYEE_SCHEDULE: {
    TITLE: `{{employeeName}}'s schedule`,
    SUMMARY: ``
  },
  SCHEDULE_NOTE: {
    TITLE: `Schedule note`,
    SUMMARY: `Leave a note for your collegues in the schedule.`,
    NO_RESULTS: `No notes for today.`,
    ADD_UPDATE_SCHEDULE_NOTE: `write one or multiple notes to add to the schedule.`
  },
  ATTACHMENTS: {
    DELETE_BUTTON: {
      TITLE: `Delete attachment`,
      SUMMARY: `Are you sure you want to delete this attachment?`,
      PRIMARY_ACTION: `Delete attachment`
    },
    OPEN_BUTTON: `Open`
  }
}
